/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Only_Sound_Firefox_PinchInputs */

const fr_only_sound_firefox_pinch = /** @type {(inputs: Only_Sound_Firefox_PinchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sombre`)
};

/**

* @param {Only_Sound_Firefox_PinchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const only_sound_firefox_pinch = /** @type {((inputs?: Only_Sound_Firefox_PinchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Only_Sound_Firefox_PinchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_only_sound_firefox_pinch(inputs)
});